module.exports = __webpack_public_path__ + "static/media/h5_superhero_bw.ee5d9f1a.webp";